import React from 'react';
import formatMoney from '../components/format-money';
import Image from './image.jsx';
import lazyImage from '../components/lazy-images';
import GridItemSwatches from '../components/ReactGridItemSwatches';

const toKebabCase = str =>
  str &&
  str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map(x => x.toLowerCase())
    .join('-');

class ProductItem extends React.Component {
  constructor(props) {
    super(props)
    this.handle = props.product.handle
    this.url = `/products/${this.handle}`
    this.price = formatMoney(parseFloat(props.product.min_price))
    this.variants = props.product.variants
    this.imageId = this.variants[0].image || props.product.images[0].id
    this.colorIndex = props.product.options.indexOf('Color')
    this.sizeIndex = props.product.options.indexOf('Size')
    this.tempUniqueColors = []
    this.uniqueColors = []
    if (~this.colorIndex) {
      this.uniqueColors = props.product.variants.filter((variant) => {
        if (!this.tempUniqueColors.includes(variant.options[this.colorIndex])) {
          this.tempUniqueColors.push(variant.options[this.colorIndex])
          return variant
        }
      })
    }

    this.sizeSort = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    this.state = {
      currentVariant: this.variants[0],
      variantURL: this.url,
      filters: [...props.filter],
      colorFilters: this.getColorFilters(),
      images: this.getImages(this.variants[0]),
      sizes: this.getSizes(this.variants[0]),
      filterCheck: true
    }
    this.gridItemSwatches = {
      _toggleExpanded: () => {},
      resize: () => {}
    };
    this.reference = React.createRef()

    this.setActiveVariant = this.setActiveVariant.bind(this)
    this.setActiveVariantEvent = this.setActiveVariantEvent.bind(this)
    this.updateImages = this.updateImages.bind(this)
    this.getSizes = this.getSizes.bind(this)
    this.getColorFromFilter = this.getColorFromFilter.bind(this)
    this.getColorFilters = this.getColorFilters.bind(this);
    // this.filterCheck = this.filterCheck.bind(this)
  }

  filterCheck() {
    let ret = true

    for (let f of Object.keys(this.props.filterObj)) {
      let matchFound = false
      for (let v of this.props.filterObj[f]) {
        if (this.props.product.tags.includes(v)) {
          matchFound = true
          break
        }
      }
      if (!matchFound) {
        ret = false
        break
      }
    }

    this.setState({
      filterCheck: ret
    })
  }

  setActiveVariantEvent(e, variantId) {
    e.preventDefault()
    this.setActiveVariant(variantId, false)
  }

  setActiveVariant(variantId, updateSwatches = true) {
    let currentVariant = this.variants.find(v => v.id === variantId)
    let currentColor = '';
    if (~this.colorIndex) {
      currentColor = `?variant=${currentVariant.id}`;
    }
    this.setState({
      currentVariant: currentVariant,
      variantURL: `/products/${this.handle}${currentColor}`,
      images: this.getImages(currentVariant),
      sizes: this.getSizes(currentVariant)
    })

    // this.props.product.title = currentVariant.title
  }

  updateImages() {
    lazyImage(this.reference.current)
  }

  getSizes(currentVariant) {
    if (!~this.sizeIndex) {
      return []
    }

    const sizes = this.variants.reduce((sizes, variant) => {
      if (!~this.colorIndex) {
        sizes.push(variant.options[this.sizeIndex].split('L x')[0])
      } else if (currentVariant.options[this.colorIndex] === variant.options[this.colorIndex]) {
        sizes.push(variant.options[this.sizeIndex].split('L x')[0])
      }
      return sizes
    }, [])
    sizes.sort(this.sizeSort.compare)
    return [...new Set(sizes)]
  }

  getImages(currentVariant) {
    const colorImages = this.props.product.images.reduce((result, element) => {
      if (element.id === currentVariant.image || (~this.colorIndex && element.alt === currentVariant.options[this.colorIndex])) {
        result.push(element.src)
      }
      return result
    }, [])

    if (!colorImages.length) {
      this.props.product.images.slice(0,2).forEach(image => colorImages.push(image.src));
    }

    return colorImages
  }

  getColorFilters() {
    return [...this.props.filter].filter((p) => {
      return p.indexOf('Color_') === 0
    })
  }

  getColorFromFilter() {
    for (let filter of this.state.colorFilters) {
      filter = filter.replace('Color_', '')
      let filterVariant = this.variants.find((v) => {
        return v.options[this.colorIndex].includes(filter)
      })
      filterVariant && this.setActiveVariant(filterVariant.id)
    }
  }

  /* static getDerivedStateFromProps(props, state) {
    console.log(state.filters, props.filter)
    if (state.filters !== props.filter) {
      this.getColorFromFilter();
      return {}
    }
    return null
  } */

  componentDidUpdate() {
    const currFilters = [...this.props.filter];
    const prevFilters = this.state.filters;
    const filtersChanged = prevFilters.length !== currFilters.length || prevFilters.some(value => !currFilters.includes(value));
    if (filtersChanged) {
      const colorFilters = this.getColorFilters();
      this.setState({ colorFilters, filters: [...this.props.filter] }, () => {
        this.getColorFromFilter();
      });
      this.gridItemSwatches.resize();
      // this.filterCheck()
    }
  }

  componentDidMount() {
    if (this.state.colorFilters.length) {
      this.getColorFromFilter();
    }
    if (this.props.filter.size) {
      // this.filterCheck()
    }
    this.gridItemSwatches = new GridItemSwatches({
      el: this.reference.current
    })
    this.gridItemSwatches.resize();
  }

  /* shouldComponentUpdate(nextProps) {
    return nextProps.changedProp !== this.state.changedProp;
  }  */

  render() {
    return <div className={`productgrid--item imagestyle--medium ${this.props.filterCheck ? '' : 'hidden'}`} data-product-item key={this.props.product.id} ref={this.reference}>
      <div className="productitem" data-product-item-content>
        <a className="productitem--image-link" data-product-page-link tabIndex="-1" href={this.state.variantURL}>
          <figure className="productitem--image">
            {this.state.images.map((image, i) => {
              let imageClass = 'productitem--image-primary';
              if (i > 0) imageClass = 'productitem--image-alternate';
              if (image)
                return <div className="product-image-wrap" key={i}>
                  <Image src={image} size="350x350" data-lazy="false" className={imageClass} onImageUpdate={this.updateImages} />
                </div>
            })}
          </figure>
        </a>
        <div className="productitem--info">
          <div className="productitem--swatches swatches-variant-images-square" data-swatches>
            <form className="productitem--swatches-container" data-swatches-container>
              {this.uniqueColors.map((variant) => {
                let variantImage = null;
                if (this.props.product.tags.includes('swatch-images')) {
                  variantImage = {src: `https://cdn.shopify.com/s/files/1/2217/9841/files/${toKebabCase(this.props.product.vendor)}-${toKebabCase(variant.options[this.colorIndex])}.jpg`};
                } else {
                  variantImage = this.props.product.images.find(i => i.id === variant.image);
                }
                const variantURL = `${this.url}?variant=${variant.id}`
                if (variantImage) {
                  return <label key={variant.id} className={this.state.currentVariant.id === variant.id ? 'current-color' : ''}>
                    <a href={variantURL} data-swatch data-swatch-tooltip={variant.options[this.colorIndex]} className="productitem--swatches-swatch-wrapper productitem--swatches-swatch-visible" onClick={(e) => this.setActiveVariantEvent(e, variant.id)}>
                      <div className="productitem--swatches-swatch">
                        <Image className="productitem--swatches-swatch-inner" src={variantImage.src} size="80x80" />
                      </div>
                    </a>
                  </label>
                }
              })}
              <button className="productitem--swatches-count-wrapper" tabIndex="0" data-swatch-count-wrapper="" aria-label="Toggle swatches" onClick={(e) => {e.preventDefault();this.gridItemSwatches._toggleExpanded()}}>
                <div className="productitem--swatches-count" data-swatch-count=""></div>
              </button>
            </form>
          </div>
          <h2 className="productitem--title"><a href={this.state.variantURL} data-product-page-link>{this.props.product.title}</a></h2>
          {(() => {
            if (this.sizeIndex > -1) {
              return <div className="productitem--sizes">
                <div className="sizes">
                  {this.state.sizes.map((size, i) => {
                    if (size)
                      return <span className="size" key={i}>{size}</span>
                  })}
                </div>
              </div>
            }
          })()
          }
          <div className="price--main"><span className="money">{this.price}</span></div>
          <div className="productitem--ratings">
            <span className="stamped-product-reviews-badge stamped-main-badge" data-id={this.props.product.id} data-product-sku={this.props.product.handle}></span>
          </div>
        </div>
      </div>
    </div>
  }
}

export default ProductItem;